import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { delay, filter, take } from 'rxjs/operators';
import { CommissioningStore } from '@store';
import { CodeScannerService } from '../../../../../shared/services';
import { ModalAction } from '../commissioning.model';
import { CommissioningService } from '../commissioning.service';

enum CodeStep {
  Type,
  Scan,
  Loading,
  Result,
}

@Component({
  selector: 'app-commissioning-code-modal',
  templateUrl: './commissioning-code-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningCodeModalComponent {
  CodeStep = CodeStep;
  activeCodeStep = CodeStep.Type;

  formGroup: FormGroup<{
    id: FormControl<string>;
    ic: FormControl<string>;
  }>;

  constructor(
    public commissioningService: CommissioningService,
    private cdr: ChangeDetectorRef,
    public codeScannerService: CodeScannerService,
    private commissioningStore: CommissioningStore
  ) {}

  onOpenQrScannerAction(): void {
    this.activeCodeStep = CodeStep.Scan;
  }

  onOpenCodeFormAction(): void {
    this.activeCodeStep = CodeStep.Type;
  }

  onLocalModalAction(action: ModalAction): void {
    const isNextStep = action === ModalAction.NextStep;
    const isPreviousStep = action === ModalAction.PreviousStep;

    if (isNextStep) {
      this.onNextStep();
    }

    if (isPreviousStep) {
      this.onPreviousStep();
    }
  }

  private onNextStep(): void {
    const isTypeStep = this.activeCodeStep === CodeStep.Type;
    const isScanStep = this.activeCodeStep === CodeStep.Scan;
    const isResultStep = this.activeCodeStep === CodeStep.Result;

    if (isTypeStep || isScanStep) {
      this.activeCodeStep = CodeStep.Loading;
      this.onValidateEuid();
    }

    if (isResultStep) {
      this.commissioningService.modalAction$.next(ModalAction.NextStep);
    }
  }

  private onPreviousStep(): void {
    const isTypeStep = this.activeCodeStep === CodeStep.Type;
    const isScanStep = this.activeCodeStep === CodeStep.Scan;
    const isResultStep = this.activeCodeStep === CodeStep.Result;

    if (isTypeStep || isScanStep) {
      this.commissioningService.modalAction$.next(ModalAction.PreviousStep);
    }

    if (isResultStep) {
      this.commissioningStore.resetEuidValidation();

      this.activeCodeStep = CodeStep.Type;
      this.cdr.markForCheck();
    }
  }

  private onValidateEuid(): void {
    this.commissioningStore.verifyEuid();

    this.commissioningStore.validateEuidResult$
      .pipe(
        filter((entry) => !!entry),
        take(1),
        delay(1500)
      )
      .subscribe(() => {
        this.activeCodeStep = CodeStep.Result;
        this.cdr.markForCheck();
      });
  }
}
